//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACCESS_TYPE_FLOW } from '@/js/constants';
import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import tasks from '@/js/tasks';
export default {
  name: 'FormSelectBiUser',
  props: {
    userBIOptions: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return Object;
      }
    },
    biType: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      userBI: null,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      MODAL_REPORT_METADATA_ACCESS: 'modalReportMetadataAccess',
      MODAL_DATASET_METADATA_ACCESS: 'modalDatasetMetadataAccess'
    };
  },
  methods: {
    openModalSelectBIUser: function openModalSelectBIUser(item) {
      var _this = this;
      this.item = item;
      this.currentModalView = this.MODAL_SELECT_USER_BI;
      this.userBI = null;
      BiUserAccessService.getUserbiByEmail().then(function (response) {
        response.data.push({
          text: window.userInfo.email,
          value: window.user.email
        });
        _this.userTableauOptions = [{
          value: null,
          text: 'Please select an user'
        }].concat(response.data);
        _this.$bvModal.show(_this.MODAL_SELECT_USER_BI);
      });
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.userBI) {
        tasks.toast.error("Please select an user.");
        //this.$toast.warning("Please select an user.")
        return;
      }
      var params = {
        //...this.item,
        dataset_id: this.biType == 'dataset' ? this.item.dataset_id : '',
        report_id: this.biType == 'report' ? this.item.report_id : '',
        user_bi: this.userBI
      };
      BiUserAccessService.checkUserHasAccess(params).then(function (response) {
        if (response.data) {
          var userSelected = _this2.userBIOptions.find(function (x) {
            return x.value == _this2.userBI;
          });
          //this.dangerMessage = ` ${userSelected.text} has already access to the ${this.biType === 'dataset' ? 'dataset': 'report'}: ${this.item.object_name}`
          //this.dismissCountDown = this.dismissSecs
          tasks.toast.error("".concat(userSelected.text, " has already access to the ").concat(_this2.biType === 'dataset' ? 'dataset' : 'report', ": ").concat(_this2.item.object_name));
          //this.$toast.warning(`${userSelected.text} has already access to the ${this.biType === 'dataset' ? 'dataset': 'report'}: ${this.item.object_name}`)
        } else {
          var _userSelected = _this2.userBIOptions.find(function (x) {
            return x.value == _this2.userBI;
          });
          _this2.$emit('onCloseModal');
          var biType = _this2.biType === 'dataset' ? _this2.MODAL_DATASET_METADATA_ACCESS : _this2.MODAL_REPORT_METADATA_ACCESS;
          if (_this2.biType === 'dataset') _this2.$emit('openMetaDataset', {
            id_inca: _this2.item.dataset_id,
            dominio: _this2.item.domain
          }, ACCESS_TYPE_FLOW.ACCESS, biType, _this2.userBI, _userSelected.text);else _this2.$emit('openMetaReport', {
            id_inca: _this2.item.report_id,
            dominio: _this2.item.domain
          }, ACCESS_TYPE_FLOW.ACCESS, biType, _this2.userBI, _userSelected.text);
        }
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onCloseModal: function onCloseModal() {
      this.$emit('onCloseModal');
    }
  }
};